import { render, staticRenderFns } from "./DraftNotificationPanel.vue?vue&type=template&id=f1a5f8a8&scoped=true"
import script from "./DraftNotificationPanel.vue?vue&type=script&lang=js"
export * from "./DraftNotificationPanel.vue?vue&type=script&lang=js"
import style0 from "./DraftNotificationPanel.vue?vue&type=style&index=0&id=f1a5f8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a5f8a8",
  null
  
)

export default component.exports